export default __webpack_public_path__ + "static/media/adorablementchien.23dd4215.jpg";